// code for shopify register and stibee form
document.addEventListener("DOMContentLoaded", function () {
  const registerForm = document.querySelector("[data-register-form] form");
  const registerButton = document.querySelector("[data-register-button]");
  const marketingCheckbox = document.querySelector("[data-register-checkbox]");
  const termsCheckbox = document.querySelector("[data-register-terms-checkbox]");
  const termsError = document.querySelector("[data-terms-error]");

  if(registerForm && registerButton && marketingCheckbox) {
    registerButton.addEventListener("click", function (e) {
      e.preventDefault();
      if(termsCheckbox.checked) {
        if(marketingCheckbox.checked) {
          const emailInput = registerForm.querySelector("[data-register-email]");
          const email = emailInput ? emailInput.value : "";

          if(email) {
            const stibeeForm = document.querySelector("[stibee-form]");

            if(stibeeForm) {
              const stibeeAction = stibeeForm.getAttribute("action");
              const stibeeData = new FormData();
              stibeeData.append("email", email);

              fetch(stibeeAction, {
                method: "POST",
                body: stibeeData,
              })
                .then((response) => {
                  if (response.ok) {
                    submitShopifyForm(registerForm);
                  } else {
                    console.error("Stibee form submission failed:", response.status);
                  }
                })
                .catch((error) => {
                  console.error("Error submitting Stibee form:", error);
                });
            }
          }
        } else {
          submitShopifyForm(registerForm);
        }
      } else {
        termsError.style.display = 'block';
      }
    });
  }

  function submitShopifyForm(form) {
    const formData = new FormData(form);

    fetch(form.action, {
      method: "POST",
      body: formData,
    })
    .then((response) => {
      if (!response.ok) {
        console.error('Error response:', response);
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      console.log('doc',doc)
      // Check if there's any error div in the response HTML
      const errorDiv = doc.querySelector('.error'); // Adjust the class name as needed
      console.log('errorDiv',errorDiv)
      if (errorDiv) {
        console.error("Registration failed, error found:", errorDiv.textContent);
        registerForm.submit();
      } else {
        console.log('successfuly submitted')
        window.location.href = "/account?status=success";
      }
    })
    .catch((error) => {
      console.error("Error during Shopify registration:", error);
    });
  }
});

// code to check input type empty for real time and email pass validation
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector("[data-register-form] form");
  const inputs = form.querySelectorAll('[data-register-text], [data-register-email], [data-register-password]'); // Include relevant input types

  inputs.forEach((input, index) => {
    input.addEventListener('focus', () => handleFocusOrInput(index));
    input.addEventListener('input', () => handleFocusOrInput(index));
  });

  function handleFocusOrInput(index) {
    const currentInput = inputs[index];
    const previousInput = inputs[index - 1];
    // Only process if the input is not a checkbox or radio
    if(currentInput.type !== 'checkbox' && currentInput.type !== 'radio') {

      if(previousInput && !previousInput.value.trim()) {
        currentInput.disabled = true;
        showMessage(currentInput, `Please fill the previous input first.`);
      } else {
        // If the previous input is filled, enable the current input and remove any error messages
        currentInput.disabled = false;
        removeMessage(currentInput);
      }

      if(currentInput.type === 'email') {
        if(!isValidEmail(currentInput.value)) {
          showMessage(currentInput, `Please enter a valid email address.`);
        } else {
          removeMessage(currentInput);
        }
      }

      // Password validation
      if(currentInput.type === 'password') {
        if(currentInput.value.length < 6) {
          showMessage(currentInput, `Password is too short (minimum 6 characters).`);
        } else {
          removeMessage(currentInput);
        }
      }
    }

    // If the current input is filled, enable the next input and remove the error message
    if(currentInput.value.trim() && inputs[index + 1]) {
      const nextInput = inputs[index + 1];
      nextInput.disabled = false;
      removeMessage(nextInput);
    }
  }

  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  function showMessage(input, message) {
    // Only show the message if it's not already present
    if(!input.nextElementSibling || !input.nextElementSibling.classList.contains('error-message')) {
      let messageSpan = document.createElement('span');
      messageSpan.className = 'error-message';
      messageSpan.style.color = 'white';
      messageSpan.style.background = '#D6001C';
      messageSpan.style.padding = '2px 4px';
      messageSpan.style.marginTop = '3px';
      messageSpan.style.width = 'fit-content';
      messageSpan.style.display = 'block';
      messageSpan.textContent = message;
      input.parentElement.appendChild(messageSpan);
    }
  }

  function removeMessage(input) {
    const message = input.parentElement.querySelector('.error-message');
    if(message) {
      message.remove();
    }
  }
});